import { Provider } from 'react-redux';
import Store from './store';
/* eslint-disable */
import React, { Component } from 'react';
/* eslint-enable */

import TopBar from './components/top-bar';
import DateNav from './components/date-nav';
import Sessions from './components/sessions';
import Resizer from './components/helpers/resizer';

// import './stylesheets/index.scss';

class WeeklyProgramme extends Component {
  state = {
    store: null,
  };

  async componentWillMount() {
    const store = await Store(this.props);
    this.setState({ store });
  }

  render() {
    const { store } = this.state;
    if (store === null) return null;
    return (
      <Provider store={store}>
        <div className="weekly-prog">
          <Resizer />
          <TopBar />
          <DateNav />
          <Sessions />
        </div>
      </Provider>
    );
  }
}

export default WeeklyProgramme;
